import React from "react";
import WorkCasePage from "../components/workcase/WorkCasePage";
import imgSvt from "../assets/img/img-work-svt.png";

function Svt() {
  return (
    <WorkCasePage
      title="svt"
      heroImage={imgSvt}
      heroAlt="svt — ausgewählte Screens und Markenauftritt"
    >
      <p>
        Lead im gesamten Online-Bereich der Unternehmensgruppe: von strategischen
        Themen über UX/UI bis zur technischen Umsetzung und Abstimmung mit
        Stakeholdern.
      </p>
      <p>
        Schwerpunkte waren konsistente Markenführung über mehrere Auftritte,
        performante Frontends und enge Zusammenarbeit mit Design und PM.
      </p>
    </WorkCasePage>
  );
}

export default Svt;
